'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Links = require('./Links/Links');

var _Links2 = _interopRequireDefault(_Links);

var _Mobile = require('./Mobile/Mobile');

var _Mobile2 = _interopRequireDefault(_Mobile);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WhiteLabelFooter = require('./WhiteLabelFooter.scss');

var _WhiteLabelFooter2 = _interopRequireDefault(_WhiteLabelFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WhiteLabelFooter = function (_PureComponent) {
    (0, _inherits3.default)(WhiteLabelFooter, _PureComponent);

    function WhiteLabelFooter() {
        (0, _classCallCheck3.default)(this, WhiteLabelFooter);
        return (0, _possibleConstructorReturn3.default)(this, (WhiteLabelFooter.__proto__ || (0, _getPrototypeOf2.default)(WhiteLabelFooter)).apply(this, arguments));
    }

    (0, _createClass3.default)(WhiteLabelFooter, [{
        key: 'render',
        value: function render() {
            var name = this.props.name;


            return (0, _jsx3.default)('div', {
                className: _WhiteLabelFooter2.default.footer
            }, void 0, (0, _jsx3.default)(_Mobile2.default, {}), (0, _jsx3.default)(_Links2.default, {
                name: name
            }));
        }
    }]);
    return WhiteLabelFooter;
}(_react.PureComponent);

exports.default = WhiteLabelFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/WhiteLabelFooter/WhiteLabelFooter.js
// module id = ja8H
// module chunks = 57